<mat-form-field appearance="outline">
  <mat-label *ngIf="!placeholder">{{ label }}</mat-label>
  <mat-select [formControl]="itemSelector" multiple="{{ allowMultiSelect }}" #select [placeholder]="placeholder || ''">
    <mat-option>
      <ngx-mat-select-search
        [formControl]="itemFiltersControl"
        [placeholderLabel]="'Search...'"
        [noEntriesFoundLabel]="'No matching options'"
      ></ngx-mat-select-search>
    </mat-option>
    <mat-option *ngFor="let item of filteredItems | async" [value]="item">{{ item[property] }}</mat-option>
  </mat-select>
</mat-form-field>
